import {SET_FILTERED_TABLE} from '../_CONSTANTS';

export const setFilteredTable = (table) => {
  return {
    type: SET_FILTERED_TABLE,
    payload: table
  }
}
